module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House58.0404ca98.jpg";